import { Card, CardBody, Col, Input, InputGroup } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ButtonsWithDropdown, ButtonsWithDropdownTitle } from "../../../../Constant";
import { BUTTON_WITH_DROPDOWN, BUTTON_WITH_DROPDOWN_1, BUTTON_WITH_DROPDOWN_2, BUTTON_WITH_DROPDOWN_3, BUTTON_WITH_DROPDOWN_4 } from "../../../../Data/FormControl/InputGroups";
import ButtonDropdownList from "./Common/ButtonDropdownList";

const ButtonsWithDropdowns = () => {
  return (
    <Col xl="6">
    <Card className="height-equal">
        <CommonCardHeader title={ButtonsWithDropdown} span={BUTTON_WITH_DROPDOWN} />
      <CardBody className="main-custom-form card-wrapper input-group-wrapper">
        <InputGroup>
          <ButtonDropdownList color='info' outline={true} title={ButtonsWithDropdownTitle} divider={true} options={BUTTON_WITH_DROPDOWN_1}/>
          <Input type="text"/>
        </InputGroup>
        <InputGroup>
          <Input type="text"/>
          <ButtonDropdownList color='danger' outline={true} title={ButtonsWithDropdownTitle} divider={true} options={BUTTON_WITH_DROPDOWN_2}/>
        </InputGroup>
        <InputGroup>
          <ButtonDropdownList color='secondary' title={ButtonsWithDropdownTitle} divider={true} options={BUTTON_WITH_DROPDOWN_3}/>
          <Input type="text"/>
          <ButtonDropdownList color='primary' title={ButtonsWithDropdownTitle} divider={true} options={BUTTON_WITH_DROPDOWN_4}/>
        </InputGroup>
      </CardBody>
    </Card>
  </Col>
  )
};

export default ButtonsWithDropdowns;
